import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=4e0de94e&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=4e0de94e&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0de94e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e0de94e')) {
      api.createRecord('4e0de94e', component.options)
    } else {
      api.reload('4e0de94e', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=4e0de94e&scoped=true", function () {
      api.rerender('4e0de94e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/returnRefund/detail.vue"
export default component.exports